import { styled } from '@mui/material/styles';
import { Fab } from "@mui/material";

const ToggleFab = styled(Fab, {
  name: 'MuiToggleFab',
  slot: 'root',
  shouldForwardProp: prop => !['active'].includes(prop),
})(({ theme, active }) => ({
  color: active ? 'white' : theme.palette.text.primary, // Cambia il colore dell'icona
  transition: 'background-color 0.3s, color 0.3s', // Transizione fluida
  ['svg']: {
    color: active ? 'white' : theme.palette.text.primary, // Cambia il colore dell'icona
  }
}));

export default ToggleFab;
